import API from './API';
var TicketIssuanceService = {
    getTicketIssuance: function (id, config) {
        return API.get("/ticket_issuances/".concat(id), config);
    },
    getTicketIssuances: function (config) {
        return API.get('/ticket_issuances', config);
    }
};
export default TicketIssuanceService;
